import { Component, Input, OnInit, DoCheck } from '@angular/core';
import { TreeNode } from 'primeng/api';

import { StudyViewModel } from '../../viewmodel/study.viewmodel';

@Component({
  selector: 'app-testedpartyinforeadonly',
  templateUrl: './testedPartyInfo_ReadOnly.component.html',
})
export class TestedPartyInfoReadOnlyComponent implements OnInit, DoCheck {
  @Input() studyVM: StudyViewModel = new StudyViewModel();
  displayTestedPartyRegionCountry: TreeNode[] = [];

  ngOnInit() {
    this.displayTestedPartyRegionCountry = this.studyVM.displayTestedPartyRegionCountry;
  }

  // During edit mode
  ngDoCheck() {
    if (this.displayTestedPartyRegionCountry.length === 0) {
      this.studyVM.displayTestedPartyRegionCountry.forEach((a) => {
        this.displayTestedPartyRegionCountry.push(a);
      });
    }
  }
}
